import { render, staticRenderFns } from "./addEditStaff.vue?vue&type=template&id=91c36e88"
import script from "./addEditStaff.vue?vue&type=script&lang=js"
export * from "./addEditStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports